import { createSpan, endSpan } from 'src/common/helpers/tracing-helper';
import { DataAddType } from '../../common/enumerations/data-add-type';
import { EntryMethod } from '../../common/enumerations/entry-method';
import { IDataInformation } from '../../common/interfaces/dtos/IDataInformation';
import { ITouchPointConfiguration } from '../../common/interfaces/dtos/ITouchPointConfiguration';
import { IItemInputData } from '../../common/interfaces/IItemInputData';
import { store } from '../../common/redux/configure-store';
import { addTransactionLine } from '../../items-list/business-logic/add-transaction-line';
import { initiateTransaction } from '../../items-list/business-logic/initiate-transaction';
import { addTransactionDataLogic } from './add-transaction-data-logic';
import { getDataInformation } from './get-data-infomation';
import { voidEmptyTransaction } from './void-transaction';

const nonRequiredCustomerDataInformationTypes: DataAddType[] = [
  DataAddType.Transaction,
  DataAddType.UserCredentials,
  DataAddType.OrderServiceTransaction,
];

export const addFirstTransactionLine = async (inputData: IItemInputData): Promise<void> => {
  const dataInformation: IDataInformation = await getDataInformation(inputData);
  const touchPointConfiguration: ITouchPointConfiguration = store.getState().touchPoint
    .touchPointConfiguration;
  const span = createSpan(`add-first-transaction-line (itemId: ${inputData.itemId})`);

  if (!dataInformation.type) {
    return;
  }

  const shouldIdentifyCustomer: boolean =
    !!touchPointConfiguration.isSaleTransactionBeginWithCustomerIdentification &&
    !nonRequiredCustomerDataInformationTypes.includes(dataInformation.type) &&
    inputData.entryMethod !== EntryMethod.Tapped;

  try {
    if (dataInformation.type !== DataAddType.Transaction) {
      await initiateTransaction();
    }

    if (shouldIdentifyCustomer) {
      // TODO: In future, perform identify customer
    } else if (
      dataInformation.type &&
      [DataAddType.Item, DataAddType.Undefined].includes(dataInformation.type)
    ) {
      await addTransactionLine(inputData);
    } else {
      await addTransactionDataLogic(dataInformation, inputData);
    }
  } catch (err) {
    await voidEmptyTransaction();
    throw err;
  } finally {
    endSpan(span);
  }
};
